
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/neet-rank-predictor",
      function () {
        return require("private-next-pages/neet-rank-predictor.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/neet-rank-predictor"])
      });
    }
  